import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import methods from '../../models/payout-methods'
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {
    Add,
    Check,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import {AclRouterLink} from "../ACL";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function PayoutMethodIndex() {
    const [payoutMethodsData, setPayoutMethodsData] = useState(null)
    const {setShowLoader} = useRootHook()

    useEffect(() => {
        setShowLoader(true)
        methods.index()//booleans are stringified to 'true' or 'false' so check validator and casting function on API
            .then((data) => {
                data && setPayoutMethodsData(data)
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [])

    if (!payoutMethodsData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Payout methods"
                breadcrumbs={[['Dashboard', '/'], ['Payout Methods', '/payout-methods']]}
                actions={
                    <Button to="/payout-methods/add" component={AclRouterLink} variant="contained" startIcon={<Add />}>
                        Add payout method
                    </Button>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto'}}>
                <TableToolbar title="Payout methods" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Method</TableCell>
                            <TableCell>Fee</TableCell>
                            <TableCell>Enabled</TableCell>
                            <TableCell>Created</TableCell>
                            <TableCell>Modified</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payoutMethodsData.map((row) => (
                            <TableRow key={`payout-${row.id}`}>
                                <TableCell>
                                    {row.id}
                                </TableCell>
                                <TableCell>
                                    <Link to={`edit?id=${row.id}`} component={RouterLink}>
                                        {row.name}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    {row.fee}
                                </TableCell>
                                <TableCell>{row.enabled ? <Check  fontSize="small" /> : ''}</TableCell>
                                <TableCell>{helpers.getDate(row.created)}</TableCell>
                                <TableCell>{helpers.getDate(row.modified)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}

